import type { User } from '#/graphql/types';
import type { Field } from '#/common/components/Form';
import type { Key } from '#/types';
import { EmailRule, RequiredRule } from 'devextreme-react/validator';
import FieldDefs from '#/types/FieldDefs';
import { rolesList } from './constants';

const fields = {
  id: {
    dataField: 'id',
    label: 'ID',
    editorOptions: { readOnly: true },
  },
  name: {
    dataField: 'name',
    label: 'Name',
    isRequired: true,
    editorOptions: { readOnly: true },
  },
  email: {
    dataField: 'email',
    label: 'Email',
    isRequired: true,
    editorType: 'TextBox',
    editorOptions: {
      mode: 'email',
      readOnly: true,
    },
    children: [
      <EmailRule key="email-email" message="Invalid email" />,
      <RequiredRule key="email-required" message="Email is required" />,
    ],
  },
  phone: {
    dataField: 'phone',
    label: 'Phone',
    editorType: 'TextBox',
    children: [<RequiredRule key="phone-required" message="Phone is required" />],
  },
  role: {
    dataField: 'role',
    label: 'Role',
    editorType: 'SelectBox',
    children: [<RequiredRule key="role-required" message="Role is required" />],
    editorOptions: {
      readOnly: true,
      items: rolesList,
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  address: {
    dataField: 'address',
    label: 'Residential Address',
    editorType: 'TextArea',
  },
  location: {
    dataField: 'location',
    label: 'Location',
  },
  groups: {
    dataField: 'groups',
    label: 'Organizations',
    editorType: 'TextBox',
    editorOptions: {
      readOnly: true,
    },
  },
} satisfies FieldDefs<User>;

export default fields;
